import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskWorkforceHistoryRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-workforce-history',
	path: '/jira/servicedesk/projects/:projectKey/settings/workforce/history',
	exact: true,
};
